package com.essntl.features.proposal.ui.proposalhistory.components

import com.essntl.features.service.domain.model.service.ServiceModel

data class JourneyRowUiState(
    val id: String,
    val index: Int,
    val startTime: String?,
    val price: Int?,
    val priceCurrencySymbol: String? = null,
    val startDate: String,
    val service: ServiceModel,
    val isItinerary: Boolean,
)